import React, { useEffect, useState } from "react";
// import styles from "./BusLayout.module.scss";
import {
  IBusLayout,
  SEAT_LAYOUT,
  SEAT_STYLE,
  SeatAvailability,
} from "../../common/types";
import { ToggleButton } from "react-bootstrap";
import { Heading } from "@radix-ui/themes";

const seatStateClass = (seat: SeatAvailability) =>
  [
    seat.isBooked ? "is-booked" : "is-not-booked",
    seat.isLadiesSeat ? "ladies-seat" : "",
    seat.isLadiesOnlyAvailable ? "ladies-only" : "",
  ]
    .filter(Boolean)
    .join(" ");

const BusLayout: React.FC<IBusLayout> = ({
  isAc = false,
  seatLayout = SEAT_LAYOUT.SINGLE_LAYER_SEATING_3X2,
  seatStyle = SEAT_STYLE.SEATING,
  seatingSeats = [],
  sleepingSeats = [],
  onToggleSeats,
  onToggleSleepers,
}) => {
  const [seatingSeatsArr, setSeatingSeatsArr] =
    useState<SeatAvailability[]>(seatingSeats);
  const [sleepingSeatsArr, setSleepingSeatsArr] =
    useState<SeatAvailability[]>(sleepingSeats);
  /* const getListStyle = (_seatLayout: SEAT_LAYOUT) => {
    let style = "";
    switch (_seatLayout) {
      case SEAT_LAYOUT.SINGLE_LAYER_SEATING_3X2:
        style = `${styles.SingleLayerSeating3x2}`;
        break;
      default:
        style = `${styles.SingleLayerSeating3x2}`;
    }

    return style;
  }; */
  /* const getListItemStyle = (_seatLayout: SEAT_LAYOUT) => {
    let style = "";
    switch (_seatLayout) {
      case SEAT_LAYOUT.SINGLE_LAYER_SEATING_3X2:
        style = `${styles.SingleLayerSeatingItem3x2}`;
        break;
      default:
        style = `${styles.SingleLayerSeatingItem3x2}`;
    }

    return style;
  }; */

  const handleSeatSelection = (evt: any) => {
    console.log(evt.target.value);
    const seatNumber = parseInt(evt.target.value);
    let _seats: SeatAvailability[] = [...seatingSeatsArr];
    _seats[seatNumber - 1].isSelected = !_seats[seatNumber - 1].isSelected;
    setSeatingSeatsArr(_seats);
  };

  const handleSleeperSelection = (evt: any) => {
    console.log(evt.target.value);
    const seatNumber = parseInt(evt.target.value);
    let _seats: SeatAvailability[] = [...sleepingSeatsArr];
    _seats[seatNumber - 1].isSelected = !_seats[seatNumber - 1].isSelected;
    setSleepingSeatsArr(_seats);
  };

  useEffect(() => {
    onToggleSeats(seatingSeatsArr);
  }, [seatingSeatsArr, onToggleSeats]);

  useEffect(() => {
    onToggleSleepers(sleepingSeatsArr);
  }, [sleepingSeatsArr, onToggleSleepers]);

  useEffect(() => {
    console.log("BusLayout=>isAc", isAc);
    console.log("BusLayout=>seatStyle", seatStyle);
    console.log("BusLayout=>seatLayout", seatLayout);
    console.log("BusLayout=>seatingSeats", seatingSeats);
    console.log("BusLayout=>sleepingSeats", sleepingSeats);
    if (seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_2X2_SLEEPING_1X1) {
    }
    setSeatingSeatsArr(seatingSeats);
    setSleepingSeatsArr(sleepingSeats);
  }, [isAc, seatStyle, seatLayout, seatingSeats, sleepingSeats]);
  return (
    <>
      <div className="row">
        {(seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_2X2_SLEEPING_1X1 ||
          seatLayout === SEAT_LAYOUT.SINGLE_LAYER_SEATING_2X2) && (
          <div className="col-sm-12 col-md-6 bus seat2-2 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Seating
            </Heading>
            {seatingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 4 === 0 && count < seatingSeatsArr.length - 1 && (
                    <div
                      className={`seat-row row-${Math.floor(count / 4) + 1}`}
                    >
                      <ol className="seats">
                        <li className="seat">
                          {seatingSeatsArr[count] && (
                            <ToggleButton
                              key={`seat-1-${count}`}
                              id={`toggle-check-seat-${seatingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(seatingSeatsArr[count])}
                              value={count + 1}
                              checked={seatingSeatsArr[count].isSelected}
                              onChange={handleSeatSelection}
                              disabled={!seatingSeatsArr[count].isAvailable}
                            >
                              {seatingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="seat"
                        >
                          {seatingSeatsArr[count + 1] && (
                            <ToggleButton
                              key={`seat-1-${count + 1}`}
                              id={`toggle-check-seat-${
                                seatingSeatsArr[count + 1].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(seatingSeatsArr[count + 1])}
                              value={count + 2}
                              checked={seatingSeatsArr[count + 1].isSelected}
                              onChange={handleSeatSelection}
                              disabled={!seatingSeatsArr[count + 1].isAvailable}
                            >
                              {seatingSeatsArr[count + 1].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        {count < seatingSeatsArr.length - 5 && (
                          <>
                            <li className="seat middle-row"></li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 3] && (
                                <ToggleButton
                                  key={`seat-1-${count + 3}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 3].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 3])}
                                  value={count + 4}
                                  checked={
                                    seatingSeatsArr[count + 3].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 3].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 3].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                        {count === seatingSeatsArr.length - 5 && (
                          <>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 3] && (
                                <ToggleButton
                                  key={`seat-1-${count + 3}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 3].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 3])}
                                  value={count + 4}
                                  checked={
                                    seatingSeatsArr[count + 3].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 3].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 3].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 4] && (
                                <ToggleButton
                                  key={`seat-1-${count + 4}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 4].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 4])}
                                  value={count + 5}
                                  checked={
                                    seatingSeatsArr[count + 4].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 4].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 4].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}

        {seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_2X1_SLEEPING_1X1 && (
          <div className="col-sm-12 col-md-6 bus seat2-2 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Seating
            </Heading>
            {seatingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 3 === 0 && count < seatingSeatsArr.length - 1 && (
                    <div
                      className={`seat-row row-${Math.floor(count / 3) + 1}`}
                    >
                      <ol className="seats">
                        <li
                          className="seat"
                        >
                          {seatingSeatsArr[count] && (
                            <ToggleButton
                              key={`seat-1-${count}`}
                              id={`toggle-check-seat-${seatingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(seatingSeatsArr[count])}
                              value={count + 1}
                              checked={seatingSeatsArr[count].isSelected}
                              onChange={handleSeatSelection}
                              disabled={!seatingSeatsArr[count].isAvailable}
                            >
                              {seatingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        {count < seatingSeatsArr.length - 4 && (
                          <>
                            <li className="seat middle-row"></li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 1] && (
                                <ToggleButton
                                  key={`seat-1-${count + 1}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 1].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 1])}
                                  value={count + 2}
                                  checked={
                                    seatingSeatsArr[count + 1].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 1].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 1].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                        {count === seatingSeatsArr.length - 4 && (
                          <>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 1] && (
                                <ToggleButton
                                  key={`seat-1-${count + 1}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 1].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 1])}
                                  value={count + 2}
                                  checked={
                                    seatingSeatsArr[count + 1].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 1].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 1].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 3] && (
                                <ToggleButton
                                  key={`seat-1-${count + 3}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 3].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 3])}
                                  value={count + 4}
                                  checked={
                                    seatingSeatsArr[count + 3].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 3].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 3].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}

        {seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_1X2_SLEEPING_1X2 && (
          <div className="col-sm-12 col-md-6 bus seat2-2 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Seating
            </Heading>
            {seatingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 3 === 0 && count < seatingSeatsArr.length - 1 && (
                    <div
                      className={`seat-row row-${Math.floor(count / 3) + 1}`}
                    >
                      <ol className="seats">
                            <li
                              className="seat"
                            >
                          {seatingSeatsArr[count] && (
                            <ToggleButton
                              key={`seat-1-${count}`}
                              id={`toggle-check-seat-${seatingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(seatingSeatsArr[count])}
                              value={count + 1}
                              checked={seatingSeatsArr[count].isSelected}
                              onChange={handleSeatSelection}
                              disabled={!seatingSeatsArr[count].isAvailable}
                            >
                              {seatingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        {count < seatingSeatsArr.length - 4 && (
                          <>
                            <li className="seat middle-row"></li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 1] && (
                                <ToggleButton
                                  key={`seat-1-${count + 1}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 1].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 1])}
                                  value={count + 2}
                                  checked={
                                    seatingSeatsArr[count + 1].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 1].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 1].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                        {count === seatingSeatsArr.length - 4 && (
                          <>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 1] && (
                                <ToggleButton
                                  key={`seat-1-${count + 1}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 1].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 1])}
                                  value={count + 2}
                                  checked={
                                    seatingSeatsArr[count + 1].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 1].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 1].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 3] && (
                                <ToggleButton
                                  key={`seat-1-${count + 3}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 3].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  className={seatStateClass(seatingSeatsArr[count + 3])}
                                  value={count + 4}
                                  checked={
                                    seatingSeatsArr[count + 3].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 3].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 3].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}

        {(seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_2X2_SLEEPING_1X1 ||
          seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_2X1_SLEEPING_1X1) && (
          <div className="col-sm-12 col-md-6 bus sleep1-1 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Sleeping
            </Heading>
            {sleepingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 2 === 0 && count < sleepingSeatsArr.length - 1 && (
                    <div
                      className={`sleeper-row row-${Math.floor(count / 2) + 1}`}
                    >
                      <ol className="sleepers">
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count] && (
                            <ToggleButton
                              key={`sleeper-1-${count}`}
                              id={`toggle-check-sleeper-${sleepingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count])}
                              value={count + 1}
                              checked={sleepingSeatsArr[count].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={!sleepingSeatsArr[count].isAvailable}
                            >
                              {sleepingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count + 1] && (
                            <ToggleButton
                              key={`sleeper-1-${count + 1}`}
                              id={`toggle-check-sleeper-${
                                sleepingSeatsArr[count + 1].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count + 1])}
                              value={count + 2}
                              checked={sleepingSeatsArr[count + 1].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={
                                !sleepingSeatsArr[count + 1].isAvailable
                              }
                            >
                              {sleepingSeatsArr[count + 1].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}

        {(seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_3X2_SLEEPING_2X1 ||
          seatLayout === SEAT_LAYOUT.SINGLE_LAYER_SEATING_3X2) && (
          <div className="col-sm-12 col-md-6 bus seat2-2 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Seating
            </Heading>
            {seatingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 5 === 0 && count < seatingSeatsArr.length - 1 && (
                    <div
                      className={`seat-row row-${Math.floor(count / 5) + 1}`}
                    >
                      <ol className="seats">
                        <li
                          className="seat"
                        >
                          {seatingSeatsArr[count] && (
                            <ToggleButton
                              key={`seat-1-${count}`}
                              id={`toggle-check-seat-${seatingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              className={seatStateClass(seatingSeatsArr[count])}
                              variant="outline-secondary"
                              value={count + 1}
                              checked={seatingSeatsArr[count].isSelected}
                              onChange={handleSeatSelection}
                              disabled={!seatingSeatsArr[count].isAvailable}
                            >
                              {seatingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="seat"
                        >
                          {seatingSeatsArr[count + 1] && (
                            <ToggleButton
                              key={`seat-1-${count + 1}`}
                              id={`toggle-check-seat-${
                                seatingSeatsArr[count + 1].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              value={count + 2}
                              className={seatStateClass(seatingSeatsArr[count + 1])}
                              checked={seatingSeatsArr[count + 1].isSelected}
                              onChange={handleSeatSelection}
                              disabled={!seatingSeatsArr[count + 1].isAvailable}
                            >
                              {seatingSeatsArr[count + 1].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        {count < seatingSeatsArr.length - 6 && (
                          <>
                            <li className="seat middle-row"></li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                      !seatingSeatsArr[count + 2].isAvailable
                                    }
                                    className={seatStateClass(seatingSeatsArr[count + 2])}
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 3] && (
                                <ToggleButton
                                  key={`seat-1-${count + 3}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 3].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 4}
                                  checked={
                                    seatingSeatsArr[count + 3].isSelected
                                  }
                                  className={seatStateClass(seatingSeatsArr[count + 3])}
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 3].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 3].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 4] && (
                                <ToggleButton
                                  key={`seat-1-${count + 4}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 4].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 5}
                                  checked={
                                    seatingSeatsArr[count + 4].isSelected
                                  }
                                  className={seatStateClass(seatingSeatsArr[count + 4])}
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 4].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 4].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                        {count === seatingSeatsArr.length - 6 && (
                          <>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 2] && (
                                <ToggleButton
                                  key={`seat-1-${count + 2}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 2].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 3}
                                  checked={
                                    seatingSeatsArr[count + 2].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 2].isAvailable
                                  }
                                  className={seatStateClass(seatingSeatsArr[count + 2])}
                                >
                                  {seatingSeatsArr[count + 2].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 3] && (
                                <ToggleButton
                                  key={`seat-1-${count + 3}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 3].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 4}
                                  checked={
                                    seatingSeatsArr[count + 3].isSelected
                                  }
                                  className={seatStateClass(seatingSeatsArr[count + 3])}
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 3].isAvailable
                                  }
                                >
                                  {seatingSeatsArr[count + 3].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 4] && (
                                <ToggleButton
                                  key={`seat-1-${count + 4}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 4].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 5}
                                  checked={
                                    seatingSeatsArr[count + 4].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 4].isAvailable
                                  }
                                  className={seatStateClass(seatingSeatsArr[count + 4])}
                                >
                                  {seatingSeatsArr[count + 4].seatNumber}
                                </ToggleButton>
                              )}
                            </li>

                            <li
                              className="seat"
                            >
                              {seatingSeatsArr[count + 5] && (
                                <ToggleButton
                                  key={`seat-1-${count + 5}`}
                                  id={`toggle-check-seat-${
                                    seatingSeatsArr[count + 5].seatNumber
                                  }`}
                                  type="checkbox"
                                  variant="outline-secondary"
                                  value={count + 6}
                                  checked={
                                    seatingSeatsArr[count + 5].isSelected
                                  }
                                  onChange={handleSeatSelection}
                                  disabled={
                                    !seatingSeatsArr[count + 5].isAvailable
                                  }
                                  className={seatStateClass(seatingSeatsArr[count + 5])}
                                >
                                  {seatingSeatsArr[count + 5].seatNumber}
                                </ToggleButton>
                              )}
                            </li>
                          </>
                        )}
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}

        {seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_3X2_SLEEPING_2X1 && (
          <div className="col-sm-12 col-md-6 bus sleep1-1 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Sleeping
            </Heading>
            {sleepingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 3 === 0 && count < sleepingSeatsArr.length - 1 && (
                    <div
                      className={`sleeper-row row-${Math.floor(count / 3) + 1}`}
                    >
                      <ol className="sleepers">
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count] && (
                            <ToggleButton
                              key={`sleeper-1-${count}`}
                              id={`toggle-check-sleeper-${sleepingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count])}
                              value={count + 1}
                              checked={sleepingSeatsArr[count].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={!sleepingSeatsArr[count].isAvailable}
                            >
                              {sleepingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count + 1] && (
                            <ToggleButton
                              key={`sleeper-1-${count + 1}`}
                              id={`toggle-check-sleeper-${
                                sleepingSeatsArr[count + 1].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count+1])}
                              value={count + 2}
                              checked={sleepingSeatsArr[count + 1].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={
                                !sleepingSeatsArr[count + 1].isAvailable
                              }
                            >
                              {sleepingSeatsArr[count + 1].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count + 2] && (
                            <ToggleButton
                              key={`sleeper-1-${count + 2}`}
                              id={`toggle-check-sleeper-${
                                sleepingSeatsArr[count + 2].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count+2])}
                              value={count + 3}
                              checked={sleepingSeatsArr[count + 2].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={
                                !sleepingSeatsArr[count + 2].isAvailable
                              }
                            >
                              {sleepingSeatsArr[count + 2].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}
        {seatLayout === SEAT_LAYOUT.TWO_LAYER_SEATING_1X2_SLEEPING_1X2 && (
          <div className="col-sm-12 col-md-6 bus sleep1-1 border-0 p-0">
            <Heading as="h2" size="3" className="mb-3" align="center">
              Sleeping
            </Heading>
            {sleepingSeatsArr.map((seat: SeatAvailability, count: number) => {
              return (
                <>
                  {count % 3 === 0 && count < sleepingSeatsArr.length - 1 && (
                    <div
                      className={`sleeper-row row-${Math.floor(count / 3) + 1}`}
                    >
                      <ol className="sleepers">
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count] && (
                            <ToggleButton
                              key={`sleeper-1-${count}`}
                              id={`toggle-check-sleeper-${sleepingSeatsArr[count].seatNumber}`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count])}
                              value={count + 1}
                              checked={sleepingSeatsArr[count].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={!sleepingSeatsArr[count].isAvailable}
                            >
                              {sleepingSeatsArr[count].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count + 1] && (
                            <ToggleButton
                              key={`sleeper-1-${count + 1}`}
                              id={`toggle-check-sleeper-${
                                sleepingSeatsArr[count + 1].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count + 1])}
                              value={count + 2}
                              checked={sleepingSeatsArr[count + 1].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={
                                !sleepingSeatsArr[count + 1].isAvailable
                              }
                            >
                              {sleepingSeatsArr[count + 1].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                        <li
                          className="sleeper"
                        >
                          {sleepingSeatsArr[count + 2] && (
                            <ToggleButton
                              key={`sleeper-1-${count + 2}`}
                              id={`toggle-check-sleeper-${
                                sleepingSeatsArr[count + 2].seatNumber
                              }`}
                              type="checkbox"
                              variant="outline-secondary"
                              className={seatStateClass(sleepingSeatsArr[count + 2])}
                              value={count + 3}
                              checked={sleepingSeatsArr[count + 2].isSelected}
                              onChange={handleSleeperSelection}
                              disabled={
                                !sleepingSeatsArr[count + 2].isAvailable
                              }
                            >
                              {sleepingSeatsArr[count + 2].seatNumber}
                            </ToggleButton>
                          )}
                        </li>
                      </ol>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default BusLayout;
